/**
 * Which permissions unlock which Settings tab — defined once, read by both the
 * page and the sidebar.
 *
 * THE BUG THIS EXISTS TO PREVENT. The shell's Settings nav entry carried its
 * own hardcoded list, `['admin.users.manage', 'admin.roles.manage']`, while the
 * page gated nine tabs on quite different permissions. Anyone whose settings
 * access was legitimate but non-admin simply had no way in: a Marketing Manager
 * with comm_settings.read, telephony, marketing and email tabs saw no Settings
 * item at all, and neither did a Sales / Front-desk Agent with telephony, tags,
 * pipelines and email. The page was right and the sidebar was wrong, and
 * nothing connected the two so nothing caught the drift.
 *
 * Three places used to carry their own copy — the sidebar, the /settings route
 * guard and the page. Add a tab here and all three learn about it together.
 */
export const SETTINGS_VIEW_PERMISSIONS = {
  team: ['admin.users.manage'],
  roles: ['admin.roles.manage'],
  tags: ['tags.read', 'tags.create'],
  pipelines: ['pipelines.read', 'pipelines.create'],
  /** telephony.update = manage credentials/pool/assignment; read = see own extension. */
  telephony: ['telephony.read', 'telephony.update'],
  /**
   * comm_settings.update = manage channels; read = view the masked config.
   * communications.link_whatsapp is here because linking a personal WhatsApp
   * is per-USER self-service, not clinic configuration — someone may hold it
   * without any business reading SMTP hosts or SMS credentials. The page shows
   * them only the unofficial WhatsApp section.
   */
  communications: ['comm_settings.read', 'comm_settings.update', 'communications.link_whatsapp'],
  email: [
    'email_settings.read',
    'email_settings.update',
    'email_identity.read',
    'email_identity.update',
  ],
  marketing: ['marketing.read', 'marketing.update'],
  /**
   * The clinic's subscription and usage. This used to be `return true` on the
   * page — accessible to everyone, including a front-desk agent with no
   * business seeing what the clinic pays. Billing is clinic administration, so
   * it follows the people who administer the clinic: Clinic Admin upwards.
   */
  plan: ['admin.users.manage', 'admin.clinics.manage'],
} as const;

export type GatedSettingsView = keyof typeof SETTINGS_VIEW_PERMISSIONS;

/**
 * Any one of these means Settings has something to show — used by the sidebar
 * entry and by the /settings route guard, which must agree or a visible nav
 * item leads to a blocked route.
 */
export const SETTINGS_ANY_PERMISSION: readonly string[] = [
  ...new Set(Object.values(SETTINGS_VIEW_PERMISSIONS).flat()),
];
